import { API, graphqlOperation } from 'aws-amplify';

import { GraphQLResult } from '@aws-amplify/api-graphql';
import { CallsByProjectIdAndCreatedAtQuery } from '../API';
import { callsByProjectIdAndCreatedAt } from '../graphql/queries';

export async function fetchLLMCallsRecursive(
  projectId: string,
  limit: number = 5,
  latestFirst: boolean = true,
  statusFilter: string = "",
  serviceFilter: string = "",
  daysBack: number = 0, // 0 means no createdDate filter
  nextToken: string | null = null,
  accumulatedCalls: any[] = []
): Promise<GraphQLResult<CallsByProjectIdAndCreatedAtQuery>> {
  let query = {
    projectId: projectId,
    sortDirection: latestFirst ? "DESC" : "ASC",
    limit: 50, // do 50 at a time
    nextToken: nextToken,
  } as any;

  if (daysBack > 0) {
    const now = new Date();
    const daysAgo = new Date(now.setDate(now.getDate() - daysBack));
    query.createdAt = {
      ge: daysAgo.toISOString(),
    };
  }

  if (statusFilter !== "" && statusFilter !== "all") {
    query.filter = {
      status: {
        eq: statusFilter,
      },
    };
  }

  if (serviceFilter !== "") {
    query.filter = {
      ...query.filter,
      serviceId: {
        eq: serviceFilter,
      },
    };
  }

  const result: GraphQLResult<CallsByProjectIdAndCreatedAtQuery> = await API.graphql(
    graphqlOperation(callsByProjectIdAndCreatedAt, query)
  ) as GraphQLResult<CallsByProjectIdAndCreatedAtQuery>;

  const calls = result.data?.callsByProjectIdAndCreatedAt?.items || [];
  const newAccumulatedCalls = [...accumulatedCalls, ...calls];
  const newNextToken = result.data?.callsByProjectIdAndCreatedAt?.nextToken;

  if (newAccumulatedCalls.length >= limit || !newNextToken) {
    return {
      ...result,
      data: {
        ...result.data,
        callsByProjectIdAndCreatedAt: {
          __typename: "ModelLLMCallConnection", // Explicitly set __typename
          ...result.data?.callsByProjectIdAndCreatedAt,
          items: newAccumulatedCalls.slice(0, limit),
          nextToken: newNextToken,
        },
      },
    };
  } else {
    return fetchLLMCallsRecursive(projectId, limit, latestFirst, statusFilter, serviceFilter, daysBack, newNextToken, newAccumulatedCalls);
  }
}
